"use strict";

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Constants = void 0;
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
var Constants = /** @class */function () {
  function Constants() {}
  Constants.keys = {
    tab: "Tab",
    enter: "Enter",
    escape: "Escape",
    space: " ",
    up: "ArrowUp",
    down: "ArrowDown",
    delete: "Delete"
  };
  return Constants;
}();
exports.Constants = Constants;